import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'map', pathMatch: 'full' },
  { path: 'login', loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent) },
  { path: 'signup', loadComponent: () => import('./pages/signup/signup.component').then(m => m.SignupComponent) },
  { path: 'map', loadComponent: () => import('./pages/map/map.component').then(m => m.MapComponent) },
  { path: 'shop/:id', loadComponent: () => import('./pages/shop-view/shop-view.component').then(m => m.ShopViewComponent) },
  { path: 'admin', loadComponent: () => import('./pages/admin/admin.component').then(m => m.AdminComponent) },
  { path: 'admin/shop/:id', loadComponent: () => import('./pages/shop-manage/shop-manage.component').then(m => m.ShopManageComponent) },
  { path: 'profile', loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent) },
];
